import {
  primaryColor,
} from "assets/jss/material-dashboard-pro-react.js";

export default {
	datetimeLabel: {
		color: '#aaa',
		fontSize: '11px',
	},
	datetimeWrapper: {
		position: 'relative',
		'& .rdt input.form-control': {
			fontSize: '14px',
			color: '#495057',
		},
	},
	datetimeIcon: {
		padding: "0px",
		position: 'absolute',
		right: '0',
		bottom: '50%',
		transform: 'translateY(50%)',
		color: '#555',
	},
  radioRoot: {
    padding: "16px",
    "&:hover": {
      backgroundColor: "unset"
    }
	},
	radio: {
    color: primaryColor[0] + "!important"
	},
	saveButton: {
		marginTop: '25px',
	},
	loadingIndicator: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
}
